import React, { useEffect, useState } from 'react';
import { useApp } from '../../context/AppContext';
import LangToggle from '../ui/LangToggle';
import ModeToggle from '../ui/ModeToggle';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { lang, mode } = useApp();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    ...(mode === 'conferenciante'
      ? [{ href: '#conferencias', es: 'Conferencias', en: 'Keynotes' }]
      : []),
    { href: '#sobre-mi', es: 'Sobre mí', en: 'About' },
    { href: '#experiencia', es: 'Experiencia', en: 'Experience' },
    { href: '#competencias', es: 'Competencias', en: 'Competencies' },
    { href: '#educacion', es: 'Formación', en: 'Education' },
    { href: '#contacto', es: 'Contacto', en: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <a href="#top" className="navbar__brand">David Luquin</a>

        <div className="navbar__links">
          {navLinks.map(l => (
            <a key={l.href} href={l.href} className="navbar__link">
              {lang === 'es' ? l.es : l.en}
            </a>
          ))}
        </div>

        <div className="navbar__controls">
          <ModeToggle />
          <LangToggle />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
